/**
 * @generated SignedSource<<3bba27a55114022c89560465abfc041f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PhotosSearchBrowseFacetFilterModal_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PhotosSearchBrowseFacetFilter_viewer">;
  readonly " $fragmentType": "PhotosSearchBrowseFacetFilterModal_viewer";
};
export type PhotosSearchBrowseFacetFilterModal_viewer$key = {
  readonly " $data"?: PhotosSearchBrowseFacetFilterModal_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PhotosSearchBrowseFacetFilterModal_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PhotosSearchBrowseFacetFilterModal_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PhotosSearchBrowseFacetFilter_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "cbd00ae2cffb2a4177ba933894c3dffe";

export default node;
